<san-modal-container
  (sanClose)="closeModal()"
  modal-size="small"
  align="center"
  block-modal-close="false"
  backdrop="true"
  [opened]="true"
>
  <div class="entities-info-modal">
    <img src="../../../assets/images/Info icon.png" />
    <div class="paragraph">
      <span class="bold">{{
        "¿Deseas modificar tus datos de contacto?" | translate
      }}</span>
      <span>{{ "Hazlo desde tu Área personal" | translate }}</span>
    </div>
    <div class="buttons-container">
      <button class="primary">
        <span>{{ "Ir al Área Personal" | translate }}</span>
      </button>
    </div>
  </div>
</san-modal-container>
